import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=5b1291ae&scoped=true"
import script from "./dataItem.vue?vue&type=script&lang=js"
export * from "./dataItem.vue?vue&type=script&lang=js"
import style0 from "./dataItem.vue?vue&type=style&index=0&id=5b1291ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1291ae",
  null
  
)

export default component.exports